export class DocumentButtonControl {
  isRegisterEnable: boolean;
  isRegisterAndPrintEnable: boolean;
  isRegisterAndPrintWithDialogEnable: boolean;
  isRegisterAsTemporaryEnable: boolean;
  isRegisterAsTemporaryAndPrintEnable: boolean;
  isPrintEnable: boolean;
  isPrintWithDialogEnable: boolean;
}
